import { TThunkAction } from '../../types/redux';
import { selectCurrentQuestionsPage } from '../../selectors/pagination';
import { setQuestionsPagination } from './actions';
import { getNewbuildingInfo } from '../../selectors/newbuildingInfo';
import { setAnswers } from '../answers';
import { fetchQuestions } from '../../services/questions';
import { getActiveSortValue } from '../../selectors/sort';
import { prepareQuestionSortRequest } from '../../mappers/prepareQuestionSort';

export const questionsPaginationRequestAction =
  (): TThunkAction<Promise<void>> => async (dispatch, getState, context) => {
    const { logger, httpApi } = context;
    const state = getState();

    const { newbuildingId } = getNewbuildingInfo(state);
    const currentPage = selectCurrentQuestionsPage(state);
    const sort = getActiveSortValue(state);

    const nextPage = currentPage + 1;

    try {
      const { answers, questions, hasMore, page } = await fetchQuestions({
        httpApi,
        parameters: {
          newbuildingId,
          page: nextPage,
          sort: prepareQuestionSortRequest(sort),
        },
      });
      dispatch(setAnswers(answers));
      dispatch(
        setQuestionsPagination({
          ...questions,
          hasMore,
          page,
        }),
      );
    } catch (error) {
      logger.error(error, {
        domain: 'questions#pagination',
        message: error.message,
      });
    }
  };
